import { render, staticRenderFns } from "./activityScreen.vue?vue&type=template&id=198707b4&scoped=true"
import script from "./activityScreen.vue?vue&type=script&lang=js"
export * from "./activityScreen.vue?vue&type=script&lang=js"
import style0 from "./activityScreen.vue?vue&type=style&index=0&id=198707b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198707b4",
  null
  
)

export default component.exports